import { Hero } from './components/Hero';
import { ConsultationTop } from './components/ConsultationTop';
import { Awards } from './components/Awards';
import { Location } from './components/Location';
import { FloorPlan } from './components/FloorPlan';
import { Amenities } from './components/Amenities';
import { Consultation } from './components/Consultation';
import { ProjectOverview } from './components/ProjectOverview';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ConsultationTop />
      <Awards />
      <Location />
      <FloorPlan />
      <Amenities />
      <Consultation />
      <ProjectOverview />
      <Footer />
    </div>
  );
}
